import axios from "axios";
import { IBooking } from "../../types";
import { ICreateBookingApiParams } from "../types";

interface IOfferParams extends Omit<ICreateBookingApiParams, "draftData"> {
    id: string
}

interface IOfferReturn extends IBooking { }

export const offer =  async ({ id, ...params }: IOfferParams): Promise<IOfferReturn> => {
    const response = await axios.post(`/booking/offer/${id}/confirm`, params);
    return response.data;
};